module.exports = __webpack_public_path__ + "static/img/fdi_logo.caf6be15.jpg";